// @flow
import type { ID_TYPE } from './common';

export type TEMPORARY_EVENT_TYPE = {
  id: ID_TYPE,
  group?: string,
  isCompleted?: boolean,
  isCanceled?: boolean,
  lifespan?: number,
  active?: boolean, // activo ?
  data?: Object,
};

export type TEMPORARY_EVENT_ADDED_TYPE = {
  type: 'TEMPORARY_EVENT_ADDED',
  payload: {
    id: ID_TYPE,
    group?: string,
    lifespan: number,
    data?: Object,
    active?: boolean,
  },
};
export const TEMPORARY_EVENT_ADDED = 'TEMPORARY_EVENT_ADDED';

export type TEMPORARY_EVENT_STARTED_TYPE = {
  type: 'TEMPORARY_EVENT_STARTED',
  payload: {
    id: ID_TYPE,
    active: boolean,
  },
};
export const TEMPORARY_EVENT_STARTED = 'TEMPORARY_EVENT_STARTED';

export type TEMPORARY_EVENT_COMPLETED_TYPE = {
  type: 'TEMPORARY_EVENT_COMPLETED',
  payload: {
    id: ID_TYPE,
    isCompleted: true,
  },
};
export const TEMPORARY_EVENT_COMPLETED = 'TEMPORARY_EVENT_COMPLETED';

export type TEMPORARY_EVENT_CANCELLED_TYPE = {
  type: 'TEMPORARY_EVENT_CANCELLED',
  payload: {
    id: ID_TYPE,
    isCanceled: true,
  },
};
export const TEMPORARY_EVENT_CANCELLED = 'TEMPORARY_EVENT_CANCELLED';

export type TEMPORARYEVENT_ACTION_TYPE =
  | TEMPORARY_EVENT_STARTED_TYPE
  | TEMPORARY_EVENT_COMPLETED_TYPE
  | TEMPORARY_EVENT_CANCELLED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/temporaryEvents.js